module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_smoker_down-ca6d0a80cce6081613262b7c5407c44c.png";